import React from "react";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import ServiceStandardsSection from "../../components/service-page/ServiceStandardsSection";
import ServiceProcessSection from "../../components/service-page/ServiceProcessSection";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import "../../styles/brand.css";
import {
  finalCtaContent,
  heroContent,
  processContent,
  servicesContent,
  supplyChainSeo,
  whyChooseContent,
} from "./supplyChainContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${supplyChainSeo.slug}`;

/* No page-level "Industries We Support" section here: this document names
   industries only inside the FSC CoC service, which that card renders itself.
   Nothing is invented to fill the gap. */

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: heroContent.h1,
    description: supplyChainSeo.description,
    url: CANONICAL,
    serviceType: "Supply chain certification and responsible sourcing consultancy",
    provider: { "@type": "Organization", name: "MBA Solutions", url: SITE_URL },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: servicesContent.title,
      itemListElement: servicesContent.standards.map((standard) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: standard.title },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: `${SITE_URL}/services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Supply Chain Certification Services",
        item: CANONICAL,
      },
    ],
  },
];

const SupplyChainCertificationServices = () => (
  <Layout
    title={supplyChainSeo.title}
    description={supplyChainSeo.description}
    keywords="supply chain certification, FSC Chain of Custody, FSC CoC consultancy, PEFC certification, responsible sourcing, supply chain traceability, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="supply-chain-page brand-page bg-white">
      <ImageBanner
        src="/assets/banners/Supply-Chain-Certification-Services.jpeg"
        alt="Supply Chain Certification Services — MBA Solutions"
        width={1737}
        height={608}
        whole
      />
      <PageIntro
        id="supply-chain-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <ServiceStandardsSection
        id="supply-chain-services-heading"
        title={servicesContent.title}
        standards={servicesContent.standards}
      />
      <ServiceProcessSection
        id="supply-chain-process-heading"
        title={processContent.title}
        steps={processContent.steps}
      />
      <WhyChooseCarousel
        id="supply-chain-why-choose-heading"
        title={whyChooseContent.title}
        reasons={toWhyChooseReasons(whyChooseContent.reasons)}
        tone="muted"
      />
      <FinalCtaPanel
        id="supply-chain-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default SupplyChainCertificationServices;
